import { render } from "./Event.vue?vue&type=template&id=46d2098a&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=46d2098a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46d2098a"

export default script